import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class DateRangeModel {
  startDate: NgbDate | null;
  endDate: NgbDate | null;
  formDate: Date | null;
  toDate: Date | null;
  constructor() {

  }
  getStartDate(): any {
    if (this.startDate) {
      const startDate = `${this.startDate.year}-${this.startDate.month.toString().padStart(2, '0')}-${this.startDate.day.toString().padStart(2, '0')}T00:00:00.000Z`;
      return startDate;
    }
    return null;
  }
  getEndDate(): any {
    if (this.endDate) {
      const endDate = `${this.endDate.year}-${this.endDate.month.toString().padStart(2, '0')}-${this.endDate.day.toString().padStart(2, '0')}T00:00:00.000Z`;
      return endDate;
    }
    return null;
  }

  getFromDate(): Date {
    return this.formDate;
  }

  getToDate(): Date {
    return this.toDate;
  }

  static ToDateRange(startDate: Date, endDate: Date): DateRangeModel {
    if (!startDate) {
      startDate = new Date();
    }
    if (!endDate) {
      endDate = new Date();
    }
    const fDate = new NgbDate(
      new Date(startDate).getFullYear(),
      new Date(startDate).getMonth() + 1,
      new Date(startDate).getDate()
    );
    const tDate = new NgbDate(
      new Date(endDate).getFullYear(),
      new Date(endDate).getMonth() + 1,
      new Date(endDate).getDate()
    );
    var range = new DateRangeModel();
    range.startDate = fDate;
    range.endDate = tDate;
    range.formDate = startDate;
    range.toDate = endDate;
    return range;
  } 
}
